// @ vendors
const get = require('lodash/object/get');

// @ utilities
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ constants
const actionTypes = require('constants/actionTypes');

function resetPreContractualInfo() {
    return {
        type: actionTypes.PRE_CONTRACTUAL_INFO_RESET
    };
}

const preContractualInfoRequest = (id, product) => ({
    type: actionTypes.PRE_CONTRACTUAL_INFO_REQUEST,
    payload: {
        id,
        product
    }
});

const preContractualInfoSucess = (id, link) => ({
    type: actionTypes.PRE_CONTRACTUAL_INFO_SUCCESS,
    payload: {
        id,
        link
    }
});

const preContractualInfoFailure = id => ({
    type: actionTypes.PRE_CONTRACTUAL_INFO_FAILURE,
    payload: {
        id
    }
});

const getPrecontractualInfoActive = (type, subtype, standard) => (dispatch) => {
    const params = {
        query: {
            idioma: 1, // @ hardcoded
            estandar: standard,
            subtipo: subtype,
            tipo: type,
        }
    };

    const id = `${type}${subtype}${standard}`;

    dispatch(preContractualInfoRequest(id, {
        type,
        subtype,
        standard
    }));
    return APIGet({
            dispatch,
            endpoint: 'requestPreContractActive',
            params
        })
        .then(response => {
            const link = get(response, 'response[0].url') || '';
            if (!!link) {
                dispatch(preContractualInfoSucess(id, link));
                return link;
            } else {
                dispatch(preContractualInfoFailure(id));
                return ''
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(preContractualInfoFailure(id));
            } else {
                throw response;
            }
        });
};

const getPrecontractualInfoActiveProduct = product => (dispatch) => {

    const id = product;
    dispatch(preContractualInfoRequest(product, {id}));
    return APIGet({
            dispatch,
            url: `${apiURLBuilder.getURL('requestPreContractActive')}/${product}`
        })
        .then(response => {
            const link = get(response, 'response[0].url') || '';
            if (!!link) {
                dispatch(preContractualInfoSucess(id, link));
                return link;
            } else {
                dispatch(preContractualInfoFailure(id));
                return ''
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(preContractualInfoFailure(id));
            } else {
                throw response;
            }
        });
};

module.exports = {
    getPrecontractualInfoActive,
    getPrecontractualInfoActiveProduct,
    resetPreContractualInfo
};
